import React, { useState } from 'react';
import { Button, Drawer, Form, Modal } from 'antd';
import { observer } from 'mobx-react';
import FormComponent from './FormComponent';
import useStore from '../../../../store';
import { Notification } from '../../../../config/Global';
import Message from '../../../../config/Message';

const AddComponent = observer((props) => {
	const { visible, onClose } = props;
	const [form] = Form.useForm();
	const { MERCHANT, AUTH } = useStore();
	const [disabled, setDisabled] = useState(true);
	const [saving, setSaving] = useState(false);

	const handleSubmit = (data) => {
		setSaving(true);
		MERCHANT.addMerchant(data)
			.then((data) => {
				Notification.success({
					message: Message().CRUD.ADD('Merchant'),
				});
				closeModal();
			})
			.catch((e) => {})
			.finally(() => setSaving(false));
	};

	const handleChange = () => {
		setTimeout(() => {
			form.validateFields({ validateOnly: true })
				.then(() => {
					setDisabled(false);
				})
				.catch(() => {
					setDisabled(true);
				});
		});
	};

	const closeModal = () => {
		AUTH.stateList = [];
		AUTH.cityList = [];
		form.resetFields();
		onClose();
	};
	return (
		<Drawer
			title="Add Merchant"
			onClose={closeModal}
			open={visible}
			destroyOnClose
			width={'43%'}
			footer={
				<div>
					<Button
						type="primary"
						key={1}
						disabled={disabled}
						htmlType="submit"
						loading={saving}
						form="AddForm"
					>
						Add Merchant
					</Button>
					<Button
						key={2}
						style={{ marginLeft: '10px' }}
						onClick={closeModal}
					>
						Cancel
					</Button>
				</div>
			}
		>
			<FormComponent
				id="AddForm"
				form={form}
				onFinish={handleSubmit}
				handleChange={handleChange}
			/>
		</Drawer>
	);
});

export default AddComponent;
